import React from 'react';
import Icon from '../../../components/AppIcon';

const StepIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="w-full px-4 md:px-6 lg:px-8 py-6 md:py-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-4 md:mb-6">
          {steps?.map((step, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;
            
            return (
              <React.Fragment key={step?.id}>
                <div className="flex flex-col items-center flex-1">
                  <div
                    className={`w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full flex items-center justify-center transition-smooth ${
                      isCompleted
                        ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
                        : isCurrent
                        ? 'bg-[var(--color-secondary)] text-[var(--color-secondary-foreground)]'
                        : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'
                    }`}
                  >
                    {isCompleted ? (
                      <Icon name="Check" size={20} />
                    ) : (
                      <span className="text-sm md:text-base lg:text-lg font-semibold">
                        {stepNumber}
                      </span>
                    )}
                  </div>
                  <p
                    className={`mt-2 text-xs md:text-sm lg:text-base text-center transition-smooth ${
                      isCurrent
                        ? 'text-[var(--color-primary)] font-semibold'
                        : 'text-[var(--color-muted-foreground)]'
                    }`}
                  >
                    {step?.title}
                  </p>
                </div>
                {index < steps?.length - 1 && (
                  <div
                    className={`h-0.5 flex-1 mx-2 transition-smooth ${
                      isCompleted
                        ? 'bg-[var(--color-primary)]'
                        : 'bg-[var(--color-muted)]'
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
        
        <div className="w-full bg-[var(--color-muted)] rounded-full h-2 md:h-3">
          <div
            className="bg-[var(--color-primary)] h-full rounded-full transition-smooth"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          />
        </div>
        
        <p className="text-center mt-3 md:mt-4 text-sm md:text-base text-[var(--color-muted-foreground)]">
          Adım {currentStep} / {totalSteps} ({Math.round((currentStep / totalSteps) * 100)}% tamamlandı)
        </p>
      </div>
    </div>
  );
};

export default StepIndicator;